import React from "react";
import {Navbar} from "./Navbar";
import Footer from "./Footer";
import { Home } from "./Home";
import { About } from "./About";
import { Technologies } from "./Technologies";
import { Projects } from "./Projects";
import { Contact } from "./Contact";
// import {Github} from "./Github";

export const MainPage=()=>{
  const homeRef = React.useRef(null);
  const aboutRef = React.useRef(null);
  const technologiesRef = React.useRef(null);
  const projectsRef = React.useRef(null);
  const contactRef = React.useRef(null);
  return (
    <div className="flex flex-col gap-y-2">
      <Navbar homeRef={homeRef} aboutRef={aboutRef} technologiesRef={technologiesRef} projectsRef={projectsRef} contactRef={contactRef} />
      <Home ref={homeRef} />
      <About ref={aboutRef} />
      <Technologies ref={technologiesRef} />
      <Projects ref={projectsRef} />
      {/* <Github/> */}
      <Contact ref={contactRef} />
      <Footer />
    </div>
  );
}